class HeartKeySizeChart extends HTMLElement {
  connectedCallback() {
    this.observer?.disconnect();
    this.observer = new MutationObserver(() => this.renderChart());
    this.observer.observe(this, { childList: true, subtree: true });
    this.renderChart();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  renderChart() {
    const source = this.querySelector('template');
    const target = this.querySelector('.hk-size-chart__content');
    if (!source || !target || target.childElementCount) return;
    const tables = Array.from(source.content.querySelectorAll('table')).filter((table) => {
      const text = table.textContent.replace(/\s+/g, ' ');
      return /サイズ|\bsize\b/i.test(text) && /着丈|身幅|肩幅|袖丈|胸囲|バスト|ウエスト|ヒップ|総丈|股下|股上|裾幅|腰囲|長さ|cm\b/i.test(text) && /\d/.test(text);
    });
    for (const table of tables) {
      const container = table.parentElement?.children.length === 1 ? table.parentElement : table;
      const before = container.previousElementSibling;
      if (before && /^(P|H[1-6])$/.test(before.tagName) && before.textContent.trim() && before.textContent.length < 100) {
        const label = document.createElement('p');
        label.textContent = before.textContent;
        target.append(label);
      }
      const copy = document.createElement('table');
      if (table.caption) {
        const caption = document.createElement('caption');
        caption.textContent = table.caption.textContent;
        copy.append(caption);
      }
      const body = document.createElement('tbody');
      for (const row of table.rows) {
        const newRow = document.createElement('tr');
        for (const cell of row.cells) {
          const newCell = document.createElement(cell.tagName.toLowerCase());
          newCell.textContent = cell.textContent.trim();
          if (cell.colSpan > 1) newCell.colSpan = cell.colSpan;
          if (cell.rowSpan > 1) newCell.rowSpan = cell.rowSpan;
          if (cell.tagName === 'TH') newCell.scope = cell.scope || 'col';
          newRow.append(newCell);
        }
        body.append(newRow);
      }
      copy.append(body);
      target.append(copy);
      const after = container.nextElementSibling;
      if (after && /誤差|採寸|平置き|寸法/.test(after.textContent) && after.textContent.length < 300) {
        const note = document.createElement('p');
        note.textContent = after.textContent;
        target.append(note);
      }
    }
    this.hidden = tables.length === 0;
  }
}

if (!customElements.get('hk-size-chart')) customElements.define('hk-size-chart', HeartKeySizeChart);
